import React from 'react'
import { connect } from 'react-redux'
import { HashLink as Link } from 'react-router-hash-link';
import { Link as RouterLink } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import LearnPagination from '../common/LearnPagination.jsx'
import { fetchWpPosts, fetchLatestWpPosts, searchWpPosts } from '../../actions/learn'

import { UilCalendar, UilClockThree, UilAngleLeft, UilAngleRight, UilAngleDoubleLeft, UilAngleDoubleRight, UilSearch, UilTimes } from '@iconscout/react-unicons'

import imgHero from '../../images/hero-learn.png'
import imgSectionOne from '../../images/img_technical_01.png'
import imgLatest1 from '../../images/latest-img-1.jpg'
import imgLatest2 from '../../images/latest-img-2.jpg'
import imgLatest3 from '../../images/latest-img-3.jpg'
import imgNotFound from '../../images/learn-not-found.png'

import { translate } from '../../helpers/global.js'

class LearnSearch extends React.Component {
  constructor(props) {
		super(props)
		this.state = {
			currentPage: 1,
			itemsPerPage: 8,
			searchValue: ''
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0)
		
		// Get search query from URL parameters
		const urlParams = new URLSearchParams(this.props.location.search)
		const searchQuery = urlParams.get('q') || ''
		
		// Set the search value in state
		this.setState({ searchValue: searchQuery })
		
		if (searchQuery.trim()) {
			// Search for posts with the query
			this.props.searchWpPosts(searchQuery, this.state.currentPage, this.state.itemsPerPage)
		} else {
			// If no search query, fetch all posts
			this.props.fetchWpPosts(this.state.currentPage, this.state.itemsPerPage)
		}
		
		// Fetch latest posts for sidebar
		this.props.fetchLatestWpPosts(4)
	}

	componentDidUpdate(prevProps) {
		// Check if search query changed
		const prevSearchQuery = new URLSearchParams(prevProps.location.search).get('q') || ''
		const currentSearchQuery = new URLSearchParams(this.props.location.search).get('q') || ''
		
		if (prevSearchQuery !== currentSearchQuery) {
			// Reset to first page when search query changes
			this.setState({ 
				currentPage: 1,
				searchValue: currentSearchQuery 
			})
			
			if (currentSearchQuery.trim()) {
				this.props.searchWpPosts(currentSearchQuery, 1, this.state.itemsPerPage)
			} else {
				this.props.fetchWpPosts(1, this.state.itemsPerPage)
			}
		}
	}

  handlePageChange = (page) => {
    const urlParams = new URLSearchParams(this.props.location.search)
    const searchQuery = urlParams.get('q') || ''
    
    this.setState({ currentPage: page })
    
    if (searchQuery.trim()) {
      this.props.searchWpPosts(searchQuery, page, this.state.itemsPerPage)
    } else {
      this.props.fetchWpPosts(page, this.state.itemsPerPage)
    }
  }

  handleFirstPage = () => {
    const urlParams = new URLSearchParams(this.props.location.search)
    const searchQuery = urlParams.get('q') || ''
    
    this.setState({ currentPage: 1 })
    
    if (searchQuery.trim()) {
      this.props.searchWpPosts(searchQuery, 1, this.state.itemsPerPage)
    } else {
      this.props.fetchWpPosts(1, this.state.itemsPerPage)
    }
  }

  handleLastPage = () => {
    const { wpPostsPagination } = this.props
    const totalPages = wpPostsPagination.get('lastPage') || 1
    const urlParams = new URLSearchParams(this.props.location.search)
    const searchQuery = urlParams.get('q') || ''
    
    this.setState({ currentPage: totalPages })
    
    if (searchQuery.trim()) {
      this.props.searchWpPosts(searchQuery, totalPages, this.state.itemsPerPage)
    } else {
      this.props.fetchWpPosts(totalPages, this.state.itemsPerPage)
    }
  }

  handlePreviousPage = () => {
    const { wpPostsPagination } = this.props
    const currentPage = wpPostsPagination.get('page') || 1
    const newPage = Math.max(1, currentPage - 1)
    const urlParams = new URLSearchParams(this.props.location.search)
    const searchQuery = urlParams.get('q') || ''
    
    this.setState({ currentPage: newPage })
    
    if (searchQuery.trim()) {
      this.props.searchWpPosts(searchQuery, newPage, this.state.itemsPerPage)
    } else {
      this.props.fetchWpPosts(newPage, this.state.itemsPerPage)
    }
  }

  handleNextPage = () => {
    const { wpPostsPagination } = this.props
    const currentPage = wpPostsPagination.get('page') || 1
    const lastPage = wpPostsPagination.get('lastPage') || 1
    const newPage = Math.min(lastPage, currentPage + 1)
    const urlParams = new URLSearchParams(this.props.location.search)
    const searchQuery = urlParams.get('q') || ''
    
    this.setState({ currentPage: newPage })
    
    if (searchQuery.trim()) {
      this.props.searchWpPosts(searchQuery, newPage, this.state.itemsPerPage)
    } else {
      this.props.fetchWpPosts(newPage, this.state.itemsPerPage)
    }
  }

  formatDate = (dateString) => {
    const date = new Date(dateString)
    const options = { year: 'numeric', month: 'short', day: 'numeric' }
    return date.toLocaleDateString('en-US', options)
  }

  decodeHtmlEntities = (text) => {
    if (!text) return text
    const textArea = document.createElement('textarea')
    textArea.innerHTML = text
    return textArea.value
  }

  // Search functionality methods
  handleSearchInputChange = (e) => {
    this.setState({ searchValue: e.target.value });
  }

  handleSearchClear = () => {
    this.setState({ searchValue: '' });
  }

  handleSearchSubmit = () => {
    if (this.state.searchValue.trim()) {
      // Update URL with new search query
      this.props.history.push(`/learn-search?q=${encodeURIComponent(this.state.searchValue.trim())}`);
    } else {
      // If search value is empty, go to learn-search without query
      this.props.history.push('/learn-search');
    }
  }

  renderBlogCards = () => {
    const { wpPosts } = this.props
    
    if (!wpPosts || wpPosts.size === 0) {
      return null // Return null instead of the no results div
    }
    
    return wpPosts.map((blog, index) => (
      <RouterLink 
        key={index} 
        to={`/learn-detail/${blog.get('id')}`} 
        className="blog-card"
        style={{textDecoration: 'none', color: 'inherit'}}
      >
        <div className="blog-card-img">
          <img src={blog.get('thumbnail') || imgLatest1} alt={blog.get('title')} />
        </div>
        <div className="blog-card-content">
          <h5>{blog.get('title')}</h5>
          <label>{blog.get('categories') && blog.get('categories').size > 0 ? this.decodeHtmlEntities(blog.get('categories').get(0)) : 'Article'}</label>
          <p className="blog-card-desc">"{blog.get('short_description')}"</p>
          <p className="hero-blog-info">
            <span><UilCalendar size="18" />{this.formatDate(blog.get('date'))}</span>
            <span><UilClockThree size="18" />{blog.get('read_duration')}</span>
          </p>
        </div>
      </RouterLink>
    ))
  }

  renderLatestBlogs = () => {
    const { latestWpPosts } = this.props
    
    if (!latestWpPosts || latestWpPosts.size === 0) {
      return <div>Loading latest posts...</div>
    }

    return latestWpPosts.slice(0, 3).map((blog, index) => (
      <RouterLink 
        key={index} 
        to={`/learn-detail/${blog.get('id')}`} 
        className="latest-blog"
        style={{textDecoration: 'none', color: 'inherit'}}
      >
        <div className="latest-img">
          <img src={blog.get('thumbnail') || imgLatest1} alt={blog.get('title')} />
        </div>
        <div className="latest-text">
          <h5>{blog.get('title')}</h5>
          <label>{blog.get('categories') && blog.get('categories').size > 0 ? this.decodeHtmlEntities(blog.get('categories').get(0)) : 'Article'}</label>
          <p className="blog-card-desc">"{blog.get('short_description')}"</p>
          <p className="hero-blog-desc">
            <span><UilCalendar size="18" />{this.formatDate(blog.get('date'))}</span>
            <span><UilClockThree size="18" />{blog.get('read_duration')}</span>
          </p>
        </div>
      </RouterLink>
    ))
  }

  renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } })

  render() {
    const { globalGetLanguages, wpPosts, wpPostsPagination, latestWpPosts, wpPostsSearchQuery } = this.props
    const currentPage = wpPostsPagination.get('page') || 1
    const perPage = wpPostsPagination.get('perPage') || 8
    const total = wpPostsPagination.get('total') || 0
    const lastPage = wpPostsPagination.get('lastPage') || 1
    
    // Get search query from URL or Redux state
    const urlParams = new URLSearchParams(this.props.location.search)
    const searchQuery = urlParams.get('q') || wpPostsSearchQuery || ''
    
    return (
      <div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />

        <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='position-relative'>
            <div className="ban-text learn-detail">
              <div className="search-container">
                <div className="search-input-container">
                  <input 
                    type="text" 
                    placeholder="Search" 
                    className="search-input"
                    value={this.state.searchValue}
                    onChange={this.handleSearchInputChange}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        this.handleSearchSubmit();
                      }
                    }}
                  />
                  {this.state.searchValue && (
                    <button 
                      className="search-clear-button" 
                      onClick={this.handleSearchClear}
                      type="button"
                    >
                      <UilTimes size="24" />
                    </button>
                  )}
                </div>
                <button 
                  className="search-button" 
                  disabled={!this.state.searchValue.trim()}
                  onClick={this.handleSearchSubmit}
                  type="button"
                >
                  <UilSearch size="24" />
                </button>
              </div>
              <div className="row">
                <div className="col-md-8">
                  {searchQuery && (
                    <div className="search-results-header hide" style={{marginBottom: '20px'}}>
                      <h3>Search Results for "{searchQuery}"</h3>
                      {total > 0 && <p>Found {total} result{total !== 1 ? 's' : ''}</p>}
                    </div>
                  )}
                  
                  {(!wpPosts || wpPosts.size === 0) ? (
                    <div className="learn-no-results">
                      <img src={imgNotFound} alt="No results found" />
                      <h2>No results found</h2>
                      <p>
                        {searchQuery 
                          ? `We couldn't find any posts matching "${searchQuery}".`
                          : "We couldn't find what you're looking for."
                        }
                        <br/>Let's try different keywords to find what you need.
                      </p>
                    </div>
                  ) : (
                    <>
                      <div className="blog-post-list search">
                        {this.renderBlogCards()}
                      </div>
                      <LearnPagination
                        currentPage={currentPage}
                        totalPages={lastPage}
                        total={total}
                        perPage={perPage}
                        onPageChange={this.handlePageChange}
                        onFirstPage={this.handleFirstPage}
                        onPreviousPage={this.handlePreviousPage}
                        onNextPage={this.handleNextPage}
                        onLastPage={this.handleLastPage}
                      />
                    </>
                  )}
                </div>
                <div className="col-md-4 latest-container">
                  <h5>Latest</h5>
                  <div className="latest-list">
                    {this.renderLatestBlogs()}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  globalGetLanguages: state.globalGetLanguages,
  wpPosts: state.wpPosts,
  wpPostsPagination: state.wpPostsPagination,
  wpPostsError: state.wpPostsError,
  wpPostsSearchQuery: state.wpPostsSearchQuery,
  wpPostsSelectedCategory: state.wpPostsSelectedCategory,
  latestWpPosts: state.latestWpPosts,
  latestWpPostsError: state.latestWpPostsError
})

const mapDispatchToProps = {
  fetchWpPosts,
  fetchLatestWpPosts,
  searchWpPosts
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LearnSearch))
